import { MyBreadcrumb, MyButton, MyModalForm, MyText } from "../../../components";
import { useTranslation } from "react-i18next";
import {
  Checkbox,
  Col, Form,
  List,
  Row,
  Spin,
  Switch,
  Tabs,
  TabsProps,
} from "antd";
import { createSearchParams, generatePath, Link, useNavigate, useParams, useSearchParams } from "react-router-dom";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  addLessonAction, copyPlanAction, editLessonAction, getCurrentPlanByCtpAction,
  getLessonAction, getOneCtpAction
} from "../../../store/pages/plans/actions";
import {
  FORM_SECTION_TYPES,
  FORM_SECTION_INNER_TYPE,
  JOURNAL_QUERY_PARAMS,
  PLANS_API,
  FORM_FORM_TYPE, PLANS_TYPES,
  ROUTE_PATH,
  DATE_FORMAT
} from "../../../constants";
import { StyledInfoContainer } from "./index.styles";
import dayjs from "dayjs";
import { PlanCard } from "../index.styles";
import { selectStore } from "../../../store/selector";
import { RootState } from "../../../store";
import { getFormAction, setFormAction, setFormActionReset } from "../../../store/common/actions";

interface IInitialState {
  visible: boolean,
  item?: any
}

export const PlansView = () => {
  const { t } = useTranslation("common")
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { ctpId } = useParams()
  const [searchParams, setSearchParams] = useSearchParams();

  const [formAddPlan] = Form.useForm()
  const [formAddLesson] = Form.useForm()
  const [formCopyLesson] = Form.useForm()


  const FORM_NAME = {
    PLANS_PLAN_ADD: 'PLANS_PLAN_ADD',
    PLANS_LESSON_ADD: 'PLANS_LESSON_ADD',
    PLANS_LESSON_COPY: 'PLANS_LESSON_COPY',
  }

  const initialState: IInitialState = {
    visible: false,
    item: {}
  }

  const modalInitialState = {
    [FORM_NAME.PLANS_PLAN_ADD]: initialState,
    [FORM_NAME.PLANS_LESSON_ADD]: initialState,
    [FORM_NAME.PLANS_LESSON_COPY]: initialState,
  }

  const {
    common: { period: periodState, form: formState, setForm },
    plans: { lessons: lessonState, oneCtp: oneCtpState }
  }: RootState = useSelector(selectStore)


  const [formModalData, setFormModalData] = useState(modalInitialState)

  const [currentPeriod, setCurrentPeriod] = useState<any>({})
  const [checkboxList, setCheckboxList] = useState<any[]>([])

  const [activeTab, setActiveTab] = useState<any>()

  useEffect(() => {
    if (ctpId) {
      dispatch(getCurrentPlanByCtpAction(ctpId))
    }
  }, [ctpId]);

  useEffect(() => {
    if (setForm.success) {
      getSelectedByID()
      dispatch(setFormActionReset())
    }
  }, [setForm])
  const getLessonsList = (tab?: any, period?: any) => {
    let bodyCtp = {
      ctp_id: ctpId,
      ...(period ? {
        start_date: period?.start_date,
        end_date: period?.end_date,
      } : {}),
      ...(tab ? {
        tab: tab
      } : {}),
    }

    dispatch(getLessonAction(bodyCtp))

    if (period) {
      setCurrentPeriod(period)
    } else {
      setCurrentPeriod({})
    }
  }
  const getSelectedByID = () => {
    const selectedID = searchParams.get('selectedTab')
    if (selectedID) {
      const finded = periodState.data.find((el) => el.id == selectedID);
      let currentKey = selectedID === 'module' || 'subject' ? selectedID : null
      const activeTab = selectedID != "final" ? Number(selectedID) : selectedID
      if (finded) {
        getLessonsList(currentKey, finded)
        setActiveTab(activeTab)
      }
    } else {
      getLessonsList(null, periodState.data?.[0])
      setActiveTab(periodState.data[0]?.id)
    }
  }
  useEffect(() => {
    getSelectedByID()
  }, [periodState.data])

  const handleClickLesson = (id: any) => {
    // @ts-ignore
    const path = {
      // @ts-ignore
      pathname: generatePath(ROUTE_PATH.LESSON_VIEW, { lessonId: id, ctpId: ctpId }),
      // @ts-ignore
      search: createSearchParams({

      }).toString()
    }

    navigate(path);
  }

  const handleImportFromExcel = () => {
    dispatch(getFormAction({
      api: PLANS_API[`${FORM_SECTION_INNER_TYPE.IMPORT}_${FORM_FORM_TYPE.LESSON}`],
      section_type: FORM_SECTION_TYPES.PLANS,
      section_inner_type: FORM_FORM_TYPE.LESSON,
      form_type: FORM_SECTION_INNER_TYPE.ADD
    }))

    setFormModalData(prevState => ({
      ...prevState,
      [FORM_NAME.PLANS_LESSON_ADD]: { ...prevState[FORM_NAME.PLANS_LESSON_ADD], visible: true }
    }))

  }

  const handleCopyLesson = () => {
    dispatch(getFormAction({
      api: PLANS_API[`${FORM_SECTION_INNER_TYPE.COPY}_${FORM_FORM_TYPE.LESSON}`],
      section_type: FORM_SECTION_TYPES.PLANS,
      section_inner_type: FORM_FORM_TYPE.LESSON,
      form_type: FORM_SECTION_INNER_TYPE.COPY,

      extra: {
        field_name: 'to_ctp_id',
        extra_value: ctpId
      }
    }))

    setFormModalData(prevState => ({
      ...prevState,
      [FORM_NAME.PLANS_LESSON_COPY]: { ...prevState[FORM_NAME.PLANS_LESSON_COPY], visible: true }
    }))
  }

  const handleAddLesson = () => {
    dispatch(getFormAction({
      api: PLANS_API[`${FORM_SECTION_INNER_TYPE.ADD}_${FORM_FORM_TYPE.PLAN}`],
      section_type: FORM_SECTION_TYPES.PLANS,
      section_inner_type: FORM_FORM_TYPE.PLAN,
      form_type: FORM_SECTION_INNER_TYPE.ADD
    }))

    setFormModalData(prevState => ({
      ...prevState,
      [FORM_NAME.PLANS_PLAN_ADD]: { ...prevState[FORM_NAME.PLANS_PLAN_ADD], visible: true }
    }))
  }

  const handleFormModalClose = () => {
    setFormModalData(modalInitialState)
  }

  const handleModalPlanFormSave = (values: any) => {
    const main: any = formState[FORM_SECTION_TYPES.PLANS][FORM_FORM_TYPE.LESSON][FORM_SECTION_INNER_TYPE.ADD].data[0]

    let body = {
      ...values,
      date_at: dayjs(values.date_at).format(DATE_FORMAT.FULL),
      ctp_id: ctpId,
      file: values.file[0]
    }

    dispatch(setFormAction({
      method: main?.method,
      path: main?.action,
      fields: body,
      action: addLessonAction
    }))

    setFormModalData(modalInitialState)
  }

  const handleModalFormSave = (values: any) => {
    const main: any = formState[FORM_SECTION_TYPES.PLANS][FORM_FORM_TYPE.PLAN][FORM_SECTION_INNER_TYPE.ADD].data[0]

    let body = {
      ...values,
      date_at: dayjs(values.date_at).format(DATE_FORMAT.FULL),
      ctp_id: ctpId
    }

    dispatch(setFormAction({
      method: main?.method,
      path: main?.action,
      fields: body,
      action: addLessonAction
    }))

    setFormModalData(modalInitialState)
  }

  const handleModalCopyLessonFormSave = (values: any) => {
    const main: any = formState[FORM_SECTION_TYPES.PLANS][FORM_FORM_TYPE.LESSON][FORM_SECTION_INNER_TYPE.COPY].data[0]

    let body = {
      ...values,
      lesson_id: checkboxList,
      ...(values.with_material ? { with_material: true } : { with_material: false }),
      ...(values.with_task ? { with_task: true } : { with_task: false }),
      ...(values.with_test ? { with_test: true } : { with_test: false }),
    }

    dispatch(setFormAction({
      method: main?.method,
      path: main?.action,
      fields: body,
      action: copyPlanAction
    }))

    setFormModalData(modalInitialState)
  }

  const handleChangeSwitch = (values: any) => {
    dispatch(setFormAction({
      method: "PUT",
      path: `edu/ctp/${ctpId}`,
      fields: { is_shared: values },
      action: editLessonAction
    }))
  }

  const handleChangeCheckbox = (values: any) => {
    setCheckboxList(values)
  }

  const tabItems = () => {
    let period = [...periodState.data, { id: 'final', name: 'Итоговые экзамены' }]

    return period?.map((item: any) => ({
      key: item.id,
      label: item.name,
      children: (
        <div style={{ padding: 24 }}>
          <Checkbox.Group style={{ width: '100%' }} onChange={handleChangeCheckbox}>
            <List rowKey={(record: any) => record.id} style={{ width: '100%' }}
              loading={lessonState.loading} pagination={{
                position: 'bottom', align: 'center', current: searchParams.get('page') ? Number(searchParams.get('page')) : 1, onChange: (page: any) => {
                  setSearchParams({ selectedTab: activeTab, page: page }, { replace: true })
                }
              }} dataSource={lessonState.data || []} renderItem={(listITem: any) => (
                <div style={{ cursor: "pointer" }}>
                  <PlanCard style={{ backgroundColor: listITem?.['background-color'] }}>

                    <Row gutter={16} align='middle'>
                      <Col span={1}>
                        <Checkbox value={listITem.id} />
                      </Col>

                      <Col onClick={() => handleClickLesson(listITem.id)} span={23}>
                        <h4>{listITem.title}</h4>
                      </Col>
                    </Row>
                  </PlanCard>
                </div>
              )} />
          </Checkbox.Group>

        </div>
      )
    }))
  }

  const handleTabChange = (key: string) => {
    let period = periodState.data
    let body = period?.find((item: any) => item.id === key)

    setActiveTab(key)
    setSearchParams({ ...searchParams, selectedTab: key }, { replace: true })

    let currentKey = key === 'module' || 'subject' ? key : null
    getLessonsList(currentKey, body)
  }

  return (
    <>
      <MyBreadcrumb title={t('back')} isBack extra={(
        <MyButton onClick={() => handleAddLesson()} ghost height={40} type="primary" htmlType="submit"
          title='Создать план занятия' />
      )} />

      <Row justify='center'>
        <Col span={20}>
          <StyledInfoContainer>
            {/*//border-color*/}
            <Spin spinning={oneCtpState.loading}>
              <Row style={{ borderBottom: '1px solid #E8E8E8', padding: 24 }}>
                <Col>
                  <h1>{t('lessonsPlan')}</h1>
                </Col>
              </Row>
              <Row justify="space-between" style={{ padding: 24 }}>
                <Col>
                  <Row gutter={[16, 16]}>
                    <Col span={24}>
                      <MyText color='rgba(140, 140, 140, 1)' size={15} style={{ marginRight: 6 }}>
                        {t('group')}:
                      </MyText>
                      <MyText>
                        {oneCtpState.data?.group}
                      </MyText>
                    </Col>
                    <Col span={24}>
                      <MyText color='rgba(140, 140, 140, 1)' size={15} style={{ marginRight: 6 }}>
                        {t('module')}:
                      </MyText>
                      <MyText>
                        {oneCtpState.data?.module}
                      </MyText>
                    </Col>
                    <Col span={24}>
                      <MyText color='rgba(140, 140, 140, 1)' size={15} style={{ marginRight: 6 }}>
                        {t('discipline')}:
                      </MyText>
                      <MyText>
                        {oneCtpState.data?.subject}
                      </MyText>
                    </Col>
                  </Row>
                </Col>

                <Col>
                  <Row justify='end' style={{ flexDirection: 'column' }}>
                    <MyButton onClick={() => handleImportFromExcel()}
                      ghost
                      height={40}
                      type="primary"
                      title={t('exportFromExcel')} />
                    <Col>
                      <Row align="middle" style={{ marginTop: 16 }}>
                        <MyText color='rgba(140, 140, 140, 1)' size={15} style={{ marginRight: 6 }}>
                          {t('makePlanPublic')}:
                        </MyText>
                        <Switch checked={oneCtpState.data?.is_shared} onChange={handleChangeSwitch} />
                      </Row>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Spin>
          </StyledInfoContainer>


          <StyledInfoContainer>
            <Tabs defaultActiveKey="1" items={tabItems()} onChange={handleTabChange} activeKey={activeTab}
              tabBarExtraContent={(
                <Row gutter={[16, 16]} style={{ marginRight: 16 }}>
                  <Col>
                    <MyButton info ghost type='primary' title={t('goToJournal')}
                      onClick={() => { navigate("/journal/" + ctpId) }} />
                  </Col>
                  <Col>
                    <MyButton info ghost type='primary' title={t('copy')} disabled={checkboxList.length <= 0}
                      onClick={handleCopyLesson} />
                  </Col>

                  {/*<Col>*/}
                  {/*  <MyButton danger title='Удалить' disabled={checkboxList.length <= 0}/>*/}
                  {/*</Col>*/}
                </Row>
              )} />
          </StyledInfoContainer>
        </Col>
      </Row>


      <MyModalForm
        formName={FORM_NAME.PLANS_PLAN_ADD}
        form={formAddPlan}
        title={formState[FORM_SECTION_TYPES.PLANS]?.[FORM_FORM_TYPE.PLAN]?.[FORM_SECTION_INNER_TYPE.ADD]?.data[0]?.title}
        visible={formModalData[FORM_NAME.PLANS_PLAN_ADD].visible}
        state={formState[FORM_SECTION_TYPES.PLANS]?.[FORM_FORM_TYPE.PLAN]?.[FORM_SECTION_INNER_TYPE.ADD]}
        onCancel={handleFormModalClose}
        onFinish={handleModalFormSave}
        period={currentPeriod}
      />

      <MyModalForm
        formName={FORM_NAME.PLANS_LESSON_ADD}
        form={formAddLesson}
        title={formState[FORM_SECTION_TYPES.PLANS]?.[FORM_FORM_TYPE.LESSON]?.[FORM_SECTION_INNER_TYPE.ADD]?.data[0]?.title}
        visible={formModalData[FORM_NAME.PLANS_LESSON_ADD].visible}
        state={formState[FORM_SECTION_TYPES.PLANS]?.[FORM_FORM_TYPE.LESSON]?.[FORM_SECTION_INNER_TYPE.ADD]}
        onCancel={handleFormModalClose}
        onFinish={handleModalPlanFormSave}
        period={currentPeriod}
      />

      <MyModalForm
        formName={FORM_NAME.PLANS_LESSON_COPY}
        form={formCopyLesson}
        title={formState[FORM_SECTION_TYPES.PLANS]?.[FORM_FORM_TYPE.LESSON]?.[FORM_SECTION_INNER_TYPE.COPY]?.data[0]?.title}
        visible={formModalData[FORM_NAME.PLANS_LESSON_COPY].visible}
        state={formState[FORM_SECTION_TYPES.PLANS]?.[FORM_FORM_TYPE.LESSON]?.[FORM_SECTION_INNER_TYPE.COPY]}
        onCancel={handleFormModalClose}
        onFinish={handleModalCopyLessonFormSave}
        period={currentPeriod}
      />
    </>
  );
};

